import axios from 'axios';

export const BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:5000'
    : 'https://myportfolio-bqyq.onrender.com';

const API = axios.create({
    baseURL: `${BASE_URL}/api`,
    withCredentials: true,
    timeout: 25000, // 25s timeout to prevent infinite pending state
});

// Request interceptor to attach JWT token fallback
API.interceptors.request.use((req) => {
    if (localStorage.getItem('userInfo')) {
        try {
            const token = JSON.parse(localStorage.getItem('userInfo')).token;
            if (token) {
                req.headers.Authorization = `Bearer ${token}`;
            }
        } catch (e) {
            console.error('Error parsing token from localStorage', e);
        }
    }
    return req;
}, (error) => {
    return Promise.reject(error);
});

// Response interceptor for unified logging / handling
API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.code === 'ECONNABORTED') {
            console.error('API request timeout - backend might be sleeping or unreachable');
        }
        return Promise.reject(error);
    }
);

export default API;
